import axios from 'axios';

// 创建 axios 实例
const http = axios.create({
  timeout: 10*1000, // 请求超时时间
});

// 封装通用的 GET 和 POST 方法
const HttpService = {
  // config 可覆盖单次请求配置（如 timeout）
  get(url, params = {}, config = {}) {
    return http.get(url, { params, ...config });
  },
  post(url, data = {}) {
    return http.post(url, data);
  },
};

export default HttpService;